export default __webpack_public_path__ + "images/0xea6887e4a9cda1b77e70129e5fba830cdb5cddef.png";